// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__5XDM9","inner":"Form_inner__2gufQ","range":"Form_range__GxHoD","name":"Form_name__2_vr9","actions":"Form_actions__1CjCo"};